import React, { Component } from 'react';
import Number from './Number';
import cloud from '../img/cloud.svg';
import downArrow from '../img/down-arrow.svg';
import '../css/App.css';

class Cloud extends Component {
  constructor(props) {
    super(props);

    this.state = {
      play: false
    }

    this.start = this.start.bind(this);
  }
  render() {
    return (
      <div className="cloud">
        <div className="cloud-img-holder">
          <img src={cloud} className="cloud-image" />
          <img src={downArrow} className="down-arrow" />
          <div className="cloud-text"><Number ref="number" number="50000" play={this.state.play} /></div>
        </div>
      </div>

    );
  }

  start() {
    if(!this.state.play) {
      this.setState({play: true});
      this.refs.number.start();
    }
  }
}

export default Cloud;



// WEBPACK FOOTER //
// ./src/js/Cloud.js